<template>
  <div class="home-container">
    <nav-list :clickIndex="clickIndex"></nav-list>
    <div class="chart-two">
      <div class="line-chart">
        <div class="date-picker" style="width: 50%;">
          <el-date-picker
              v-model="selectDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="getuseractivedata"
              :picker-options="pickerOptions"
          >
          </el-date-picker>
      </div>
        <div
            id="dayActive"
            v-loading="loading"
            element-loading-text="加载中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.1)"
            style="width: 100%;height: 100%;"
        ></div>
      </div>

      <div class="line-chart">
        <div class="top-select">
          <div class="date-picker" style="width: 50%;">
          <el-date-picker
              v-model="selectDate2"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="getMonList"
              :picker-options="pickerOptions2"
          >
          </el-date-picker>
        </div>
        <div style="width: 50%; margin-left: 10px;">
          <el-cascader
            clearable
            v-model="cityValue"
            :options="flattenedOptions"
            :show-all-levels="false"
            :props="cityProps"
            @change="cityChange">
          </el-cascader>
        </div>
        </div>
        <div
            id="monActive"
            v-loading="loading2"
            element-loading-text="加载中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.1)"
            style="width: 100%;height: 100%;"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getScreenIndex,
  getUserData,
  getKaihuList,
  getKaihuCityList,
  getCityList
} from "@/api/homeIndex/homeIndex";
import navList from "@/components/navList/navList.vue";

import {
  getDayActiveList,
  getMonActiveList
} from "@/api/inviteIndex/inviteIndex";
import "echarts/extension/bmap/bmap";
export default {
  name: "homeIndex",
  components: {
    navList
  },
  data() {
    return {
      cityProps: {
        value: 'name',
        label: 'name',
        children: 'cities'
      },
      cityValue: '合肥市',
      selectDate: "",
      selectDate2: '',
      // 日期时间范围在一个月以内
      pickerOptions: {
        onPick: ({maxDate, minDate}) => {
          this.selectDate = minDate.getTime();
          if (minDate && !maxDate) {
            this.timeOptionRange = minDate;
          }
          if (maxDate) {
            this.selectDate = "";
            this.timeOptionRange = null;
          }
        },
        disabledDate: (time) => {
          let timeOptionRange = this.timeOptionRange;
          if (
              timeOptionRange &&
              time.getTime() === timeOptionRange.getTime()
          )
            return true;
          if (this.selectDate !== "") {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return (
                time.getTime() < minTime || time.getTime() > maxTime
            );
          }
        },
      },

      pickerOptions2: {
        onPick: ({maxDate, minDate}) => {
          this.selectDate2 = minDate.getTime();
          if (minDate && !maxDate) {
            this.timeOptionRange = minDate;
          }
          if (maxDate) {
            this.selectDate2 = "";
            this.timeOptionRange = null;
          }
        },
        disabledDate: (time) => {
          let timeOptionRange = this.timeOptionRange;
          if (
              timeOptionRange &&
              time.getTime() === timeOptionRange.getTime()
          )
            return true;
          if (this.selectDate2 !== "") {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.selectDate2 - one;
            const maxTime = this.selectDate2 + one;
            return (
                time.getTime() < minTime || time.getTime() > maxTime
            );
          }
        },
      },
      clickIndex: 2,

      indexObj: {},
      pickerTime: "",
      loading: true,
      loading2: true,
      topData: [],
      dataType: "",
      scrollView: false,
      lineOpiton: {
        title: {
          text: "",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["预约量", "完成量"],
          textStyle: {
            color: "#fff",
          },
          left: "3%"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },

        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
          axisLabel: {
            textStyle: {
              color: "#fff",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            textStyle: {
              color: "#fff",
            },
          },
        },
        series: [
          {
            name: "预约量",
            type: "line",
            stack: "yuyue",
            data: [],
          },
          {
            name: "完成量",
            type: "line",
            stack: "deal",
            data: [],
          }
        ],
      },

      lineOpiton2: {
        title: {
          text: "",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["预约量", "完成量"],
          textStyle: {
            color: "#fff",
          },
          left: "3%"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },

        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
          axisLabel: {
            textStyle: {
              color: "#fff",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            textStyle: {
              color: "#fff",
            },
          },
        },
        series: [
          {
            name: "预约量",
            type: "line",
            stack: "yuyue",
            data: [],
          },
          {
            name: "完成量",
            type: "line",
            stack: "deal",
            data: [],
          }
        ],
      },

      regionData: []
    };
  },
  computed: {
    flattenedOptions() {
      return this.regionData.map(province => {
        // 深拷贝第一级
        const provinceClone = { ...province };
        
        // 处理第二级：移除第三级children
        if (provinceClone.cities) {
          provinceClone.cities = provinceClone.cities.map(city => ({
            id: city.id,
            name: city.name
            // 不保留children属性，第三级自动隐藏
          }));
        }
        
        return provinceClone;
      });
    },
  },
  watch: {},
  created() {
    let startDate = this.$moment().format("YYYY-MM-DD");
    let endDate = this.$moment().add(0, "days").format("YYYY-MM-DD");
    let monDate = this.$moment().subtract(1, "months").format("YYYY-MM-DD");
    this.pickerTime = [startDate, endDate];
    this.selectDate = [monDate, startDate];
    this.selectDate2 = [monDate, startDate]
    this.getCityListData()
  },
  mounted() {
    this.$nextTick(() => {
      this.getuseractivedata();
      this.getMonList();
    });
    this.getWebSocket();
  },

  props: [],
  methods: {
    getCityListData() {
      getCityList().then(res => {
        if(res.data.code == 1) {
          this.regionData = res.data.data
        }
      })
    },

    cityChange(e) {
      console.log(e)
      this.cityValue = e[1]
      this.getMonList()
    },

    // 获取对于时间范围用户活跃数据
    getuseractivedata(e = null) {
      console.log(e);
      this.loading = true
      if (!e)
        var obj = {
          start_date: this.selectDate[0],
          end_date: this.selectDate[1],
        };
      else
        var obj = {
          start_date: e[0],
          end_date: e[1],
        };
      getKaihuList(obj).then((res) => {
        this.loading = false
        console.log(res);
        let xData = [];
        let deal = [];
        let yuyue = [];
        res.data.data.forEach((val) => {
          xData.push(val.date);
          deal.push(val.deal);
          yuyue.push(val.yuyue);

        });
        this.lineOpiton.xAxis.data = xData;
        this.lineOpiton.series[0].data = yuyue;
        this.lineOpiton.series[1].data = deal;
        this.$echarts
            .init(document.getElementById("dayActive"))
            .setOption(this.lineOpiton);
      });
    },


    // 获取对于时间范围用户活跃数据
    getMonList(e = null) {
      this.loading2 = true
      console.log(e, 'getMonList');
      console.log(this.selectDate2, 'selectDate2')
      if (!e)
        var obj = {
          start_date: this.selectDate2[0],
          end_date: this.selectDate2[1],
          city: this.cityValue
        };
      else
        var obj = {
          start_date: e[0],
          end_date: e[1],
          city: this.cityValue
        };
      getKaihuCityList(obj).then((res) => {
        this.loading2 = false
        let xData = [];
        let yuyue = []
        let deal = []
        res.data.data.forEach(val => {
          xData.push(val.date);
          yuyue.push(val.yuyue)
          deal.push(val.deal)
        })
        this.lineOpiton2.xAxis.data = xData;
        this.lineOpiton2.series[0].data = yuyue;
        this.lineOpiton2.series[1].data = deal;
        this.$echarts
            .init(document.getElementById("monActive"))
            .setOption(this.lineOpiton2);
      });
    },

    getWebSocket() {
      this.$goeasy.connect({
        onSuccess: function () {
          //连接成功
          console.log("GoEasy connect successfully."); //连接成功
        },
        onFailed: function (error) {
          //连接失败
          console.log(
              "Failed to connect GoEasy, code:" +
              error.code +
              ",error:" +
              error.content
          );
        },
        onProgress: function (attempts) {
          //连接或自动重连中
          console.log("GoEasy is connecting", attempts);
        },
      });
      let pubsub = this.$goeasy.pubsub;
      let _that = this;
      pubsub.subscribe({
        channel: "screen_channel", //替换为您自己的channel
        onMessage: function (message) {
          console.log("是否能从服务端主动接收到消息");
          _that.scrollView = !_that.scrollView;
        },
        onSuccess: function () {
          console.log("Channel订阅成功。");
        },
        onFailed: function (error) {
          console.log(
              "Channel订阅失败, 错误编码：" +
              error.code +
              " 错误信息：" +
              error.content
          );
        },
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/home.scss";
@import "@/styles/common.scss";

.header-cell {
  color: #61d2f7 !important;
  font-size: 14px;
  font-weight: 600;
  height: 48px;
  background-color: #072951 !important;
  box-shadow: -10px 0px 15px #034c6a inset, 10px 0px 15px #034c6a inset;
}

.row-cell {
  color: #fff !important;
  background-color: #072951 !important;
}

.row-cells {
  color: #fff !important;
  background-color: #072951 !important;
  box-shadow: -10px 0px 15px #034c6a inset, 10px 0px 15px #034c6a inset;
}

.chart-two {
  padding-top: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;

  .line-chart {
    width: 100%;
    height: calc(100vh - 160px) !important;
  }
}

.picker-list {
  display: flex;
  align-items: center;
}
</style> 
